
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PatentDescService } from '../patent-desc-service';
import { PatentDescApi } from '@telecom/shared/infrastructure/api-functions/patent-desc-api';

@injectable()
export class PatentDescServiceImpl implements PatentDescService {
    constructor(
        @inject(PatentDescApi)
        private readonly _patentDescApi: PatentDescApi,
    ) {}
    getPatentDesc(payload: {patentId: string ,lang: string}): Promise<string> {
        return this._patentDescApi.getPatentDesc(payload);
    }
}
